import { delFts, get, getFile, postPDF } from "./httpBridge";

// Бридж для работы с PDF файлами
export default function Bridge() {
    return {
      // загрузка PDF на сервер
      uploadFiles: async (files, info, sessionId) => postPDF(files, sessionId, info),

      //TODO ПОМЕНЯТЬ ЗАПРОСЫ
      //////////////
      // получение списка файлов по id товара и размеру
      listFiles: async (productId, size, client_id, market) => get('products/pdf-files', {productId: productId, size: size, client_id, market}),
      // получение списка страниц по id товара и размеру
      countPages: async (productId, size, client_id, market) => get('products/total-pages', {productId: productId, size: size, client_id, market}),
      ///////////////
      // получение файла по пути
      getFile: async (path) => getFile('pdf', {path:path}),
      // удаление страниц в файле 
      deletePages: async (path, pages, sessionId) => 
        {
          return await delFts('/delete-pages', {path:path, pages:pages}, sessionId)
        },
      // удаление файлов
      deleteFiles: async (pathes, sessionId) => 
        {
          return await delFts('/delete-file', {path:pathes, taskType: "delPDF"}, sessionId)
      }
    };
  }